// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__21vGh","itemSelecionado":"Item_itemSelecionado__Re92n","itemCompletado":"Item_itemCompletado__Rz6qm","concluido":"Item_concluido__3MKsB"};